
/* Aluminox draft only: remember custom drain-plate dimensions across variant changes. */
(function () {
  if (!/\/products\/[^/]*(drain|garage-drain)/i.test(location.pathname)) return;

  var remembered = { length: null, width: null };
  var activeUntil = 0;
  var restoring = false;
  var restoreTimer = null;

  function dimension(input) {
    if (!input || !input.matches('input[type="number"], input[type="text"]')) return null;
    if (input.closest('variant-picker')) return null;
    var labels = [input.name || '', input.id || '', input.getAttribute('aria-label') || ''];
    if (input.labels) Array.from(input.labels).forEach(function (label) {
      labels.push(label.textContent || '');
    });
    var wrapper = input.parentElement;
    if (wrapper) {
      var label = wrapper.querySelector('label');
      if (label) labels.push(label.textContent || '');
    }
    var labelText = labels.join(' ');
    if (/\b(length|longueur)\b/i.test(labelText)) return 'length';
    if (/\b(width|largeur)\b/i.test(labelText)) return 'width';
    return null;
  }

  document.addEventListener('input', function (event) {
    if (!event.isTrusted || restoring) return;
    var key = dimension(event.target);
    if (key) remembered[key] = event.target.value;
  }, true);

  function putBack() {
    if (Date.now() > activeUntil || restoring) return;
    restoring = true;
    document.querySelectorAll('input').forEach(function (input) {
      var key = dimension(input);
      if (!key || remembered[key] === null || input.value === remembered[key]) return;
      var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
      setter.call(input, remembered[key]);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    restoring = false;
  }

  function beginRestore() {
    if (remembered.length === null && remembered.width === null) return;
    activeUntil = Date.now() + 3000;
    [30, 120, 350, 700, 1400, 2400].forEach(function (delay) {
      setTimeout(putBack, delay);
    });
  }
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('variant-picker')) beginRestore();
  }, true);
  document.addEventListener('variant:changed', beginRestore);
  new MutationObserver(function () {
    if (Date.now() <= activeUntil) {
      clearTimeout(restoreTimer);
      restoreTimer = setTimeout(putBack, 15);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
